/* Backend may return the literal "Venn" as a data source. Swap it for the app title so the retired
 * brand name does not leak into the UI. */
import { getAppTitle } from './getAppTitle';

export const rebrandDataSource = (dataSource: string | undefined): string | undefined =>
  dataSource?.trim().toLowerCase() === 'venn' ? getAppTitle() : dataSource;
